module.exports = __webpack_public_path__ + "static/media/balance-scale.3cf357f8.svg";